import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { hasPermission } from '../utils/permissionUtils';
import Services from '../WebView/Services/Services';
import Appoinments from '../WebView/Appoinments/Appoinments';
import AddStaff from '../WebView/Staff/AddStaff';
import Staff from '../WebView/Staff/Staff';
import Advertiesment from '../WebView/Advertiesment/Advertiesment';
import AddAdvertiesment from '../WebView/Advertiesment/AddAdvertiesment';
import BillBoardAds from '../WebView/Advertiesment/BillBoard/BillBoardAds';
import AddBillBoard from '../WebView/Advertiesment/BillBoard/AddBillBoard';
import Dashboard from '../WebView/Dashboard/Dashboard';
import FileUpload from '../WebView/Upload/FileUpload';
import Products from '../WebView/Products/Products';
import AddProducts from '../WebView/Products/AddProducts';
import AddParent from '../WebView/Services/Parent/AddParent';
import AddChild from '../WebView/Services/Child/AddChild';
import RoleMaster from '../WebView/RoleManagement/RoleMaster';
import AddRole from '../WebView/RoleManagement/AddRole';
import UserMaster from '../WebView/UsersManagement/UserMaster';
import AddUser from '../WebView/UsersManagement/AddUser';
import Askai from '../WebView/Askai/Askai';
import GeneralMaster from '../WebView/GeneralMaster/GeneralMaster';
import AddGeneralMaster from '../WebView/GeneralMaster/AddGeneralMaster';
import SeatMaster from '../WebView/SeatManagement/SeatMaster';
import AddSeat from '../WebView/SeatManagement/AddSeat';
import FloorMaster from '../WebView/FloorManagement/FloorMaster';
import ClientMaster from '../WebView/ClientManagement/ClientMaster';
import AddClient from '../WebView/ClientManagement/AddClient';
import AddUnit from '../WebView/Unit Management/AddUnit';
import UnitMaster from '../WebView/Unit Management/UnitMaster';
import StaffDashboard from '../WebView/StaffDashboard/StaffDashboard/StaffDashboard';
import StaffAttendance from '../WebView/StaffDashboard/StaffAttendence/StaffAttendence';
import VendorManagement from '../WebView/VendorManagement/VendorManagement';
import AddVendor from '../WebView/VendorManagement/AddVendor';
import BillingSearch from '../WebView/Billing/QuickSale';
import Test from '../WebView/test';
import Membership from '../WebView/MemberShip/Membership'
import AddMembship from '../WebView/MemberShip/AddMembship'
import EditChildService from '../WebView/Services/Child/EditChildService';
import { getElevateUser } from '../storage/Storage';
import RateCard from '../WebView/RateCard/RateCard';
import EditRole from '../WebView/RoleManagement/EditRole';
import TaskMaster from '../WebView/TaskManagement/TaskMaster';
import AddTask from '../WebView/TaskManagement/AddTask';
import MyTask from '../WebView/TaskManagement/MyTask';
import EditTask from '../WebView/TaskManagement/EditTask';
import AddSurvey from '../WebView/Survey/AddSurvey';
import Survey from '../WebView/Survey/CreateSurvey';
import NoGstBills from '../WebView/Billing/NoGstBills';
import AddExpense from '../WebView/Expense/AddExpense';
import Expense from '../WebView/Expense/Expense';
import ClosingDays from '../WebView/ClosingDays/ClosingDays';
import WalletManagement from '../WebView/WalletManagement/WalletManagement';
import Packages from '../WebView/Packages/Packages';
import AddPackage from '../WebView/Packages/AddPackage';
import QuickSaleMaster from '../WebView/QuickSale/QuickSaleMaster';
import CouponMaster from '../WebView/CouponManagement/CouponMaster';
import AddCoupon from '../WebView/CouponManagement/AddCoupon';
import AccountMaster from '../WebView/AccountManagement/AccountMaster';
import AddAccount from '../WebView/AccountManagement/AddAccount';
import IncentiveMaster from '../WebView/IncentiveManagement/IncentiveMaster';
import AddIncentive from '../WebView/IncentiveManagement/AddIncentive';
import AttendanceMaster from '../WebView/AttendanceManagement/AttendanceMaster';
import WhatsappMaster from '../WebView/WhatsappManagement/WhatsappMaster';
import BillMaster from '../WebView/BillsManagement/BillMaster';
import PaymentMaster from '../WebView/PaymentManagement/PaymentMaster';
import AppBookingMaster from '../WebView/AppBookingManagement/AppBookingMaster';
import Warehouse from '../WebView/StockManagement/Warehouse/Warehouse';
import AddWarehouse from '../WebView/StockManagement/Warehouse/AddWarehouse';
import TransferStock from '../WebView/StockManagement/Warehouse/TransferStock';
import Professionals from '../WebView/StockManagement/Professionals/Professionals';
import Retails from '../WebView/StockManagement/Retails/Retails';
import StockDashboard from '../WebView/StockManagement/Dashboard/StockDashboard';
import BuyStockMaster from '../WebView/BuyStock/BuyStockMaster';
import Orders from '../WebView/BuyStock/Orders/Orders';
import Billing from '../WebView/Billing/Billing';
import AutoBillingPage from '../WebView/StaffBilling/AutoBillingPage';
import StaffBillManagement from '../WebView/StaffBilling/StaffBillManagement';
import AutoBillingMaster from '../WebView/AutoBillingManagement/AutoBillingMaster';
import ClientAndPay from '../WebView/AutoBillingManagement/ClientAndPay';
import EditStafffBill from '../WebView/StaffBilling/EditStafffBill';
import EditQuickSale from '../WebView/EditVersionQuicksale/EditQuickSale';
import ClientFollowup from '../WebView/ClientFollowups/ClientFollowup';
import ClientFeedback from '../WebView/ClientFeedback/ClientFeedback';
import AddClientFollowup from '../WebView/ClientFollowups/AddClientFollowup';
import StaffReportMaster from '../WebView/ReportsManagement/StaffReports/StaffReportMaster';
import PaymentDistributionReport from '../WebView/ReportsManagement/PaymentDistribution/PaymentDistributionReport';
import RegisterDevice from '../WebView/Advertiesment/DeviceRegister/RegisterDevice';
import DeviceMaster from '../WebView/Advertiesment/DeviceRegister/DeviceMaster';
import DeviceAds from '../WebView/Advertiesment/DeviceRegister/DeviceAds';
import AppoinmentMaster from '../WebView/AppoinmentManagement/AppoinmentMaster';
import AppointmentManagementMaster from '../WebView/AppoinmentManagement/AppointmentManagementMaster';
import KioskManagement from '../WebView/KioskManagement/KioskManagement';
import HomeScreenManagement from '../WebView/KioskManagement/HomeScreenManagement/HomeScreenManagement';
import KioskDashboard from '../WebView/KioskManagement/KioskDashboard/KioskDashboard';
import BannerManagement from '../WebView/KioskManagement/BannerManagement/BannerManagement';
import AdManagement from '../WebView/KioskManagement/AdManagement/AdManagement';
import SalonService from '../WebView/SalonService/SalonService';
import AddSalonParent from '../WebView/SalonService/SalonParent/AddSalonParent';
import AddSalonChild from '../WebView/SalonService/SalonChild/AddSalonChild';
import EditSalonChild from '../WebView/SalonService/SalonChild/EditSalonChild';
import ClientAnalytics from '../WebView/ClientAnalytics/ClientAnalytics';
import BusinessForecasting from '../WebView/BusinessForecasting/BusinessForecasting';
import AttendanceReport from '../WebView/ReportsManagement/AttendanceReport';
import BillReportMaster from '../WebView/ReportsManagement/BillReports/BillReportMaster';
import KioskServices from '../WebView/KioskManagement/KioskServices/KioskServices';
import AddKiosParent from '../WebView/KioskManagement/KioskServices/KiosParent/AddKiosParent';
import AddKiosChild from '../WebView/KioskManagement/KioskServices/KiosChild/AddKiosChild';
import EditKiosChild from '../WebView/KioskManagement/KioskServices/KiosChild/EditKiosChild';
import KiosQuicksale from '../WebView/KioskManagement/KiosQuicksale/KiosQuicksale';

import BestServices from '../WebView/BestServices/BestServices';
import AddBestService from '../WebView/BestServices/AddBestService';
import ClientWebApp from '../WebView/ClientWebview/ClientWebApp';
import HomeServices from '../WebView/AtHomeServices/HomeServices';
import AddAtHomeParent from '../WebView/AtHomeServices/HomeParent/AddAtHomeParent';
import AddAtHomeChild from '../WebView/AtHomeServices/HomeChild/AddAtHomeChild';
import EditAtHomeChild from '../WebView/AtHomeServices/HomeChild/EditAtHomeChild';
import MasterService from '../WebView/MasterService/MasterService';
import ServiceDashboard from '../WebView/ServiceDashboard/ServiceDashboard';
import ProductMaster from '../WebView/ProductMaster/ProductMaster';
import InventoryManagement from '../WebView/InventoryManagement/InventoryManagement';
import HairColorServices from '../WebView/HairColorManagement/HairColorServices';
import HairColorManagement from '../WebView/HairColorManagement/HairColorManagement';
import AtHomeBillMaster from '../WebView/AtHomeBills/AtHomeBillMaster';
import PaymentMethod from '../WebView/PaymentQRManagement/PaymentMethod';
import WebsiteConfiguration from '../WebView/WebsiteConfiguration/WebsiteConfiguration';
import AppControl from '../WebView/AppControl/AppControl';
import PartnerAppControl from '../WebView/PartnerAppControl/PartnerAppControl';
import PartnerAnalytics from '../WebView/PartnerAppControl/PartnerAnalytics/PartnerAnalytics';
import PartnerMap from '../WebView/PartnerAppControl/PartnerMap/PartnerMap';
import OtaUpdates from '../WebView/PartnerAppControl/OtaUpdates/OtaUpdates';
import ClientOtaUpdates from '../WebView/AppControl/OtaUpdates/ClientOtaUpdates';
import HomeServicesMaster from '../WebView/HomeServices/HomeServices';
import CategoryMaster from '../WebView/AppControl/CategoryHandling/CategoryMaster';
import AddCategory from '../WebView/AppControl/CategoryHandling/AddCategory';
import NotificationMaster from '../WebView/AppControl/Notifications/NotificationMaster';
import SendNotification from '../WebView/AppControl/Notifications/SendNotification';
import ServiceGroupConfig from '../WebView/AppControl/ServiceGroupConfig/ServiceGroupConfig';
import MaintenanceModeMaster from '../WebView/AppControl/MaintenanceMode/MaintenanceModeMaster';
import AddMaintenanceMode from '../WebView/AppControl/MaintenanceMode/AddMaintenanceMode';
import LiveUsers from '../WebView/AppControl/LiveUsers/LiveUsers';
import VersionMaster from '../WebView/AppControl/VersionControl/VersionMaster';
import AddVersion from '../WebView/AppControl/VersionControl/AddVersion';

// Protected Route Component using the utility functions
const ProtectedRoute = ({ children, module, action = 'read', childType = null }) => {
  const userHasPermission = hasPermission(module, action, childType);

  if (!userHasPermission) {
    return <Navigate to="/unauthorized" replace />;
  }
  return children;
};

// Unauthorized Component
const Unauthorized = () => (
  <div className="flex items-center justify-center min-h-screen bg-gray-100">
    <div className="text-center">
      <h1 className="text-4xl font-bold text-red-600 mb-4">Access Denied</h1>
      <p className="text-gray-700 mb-6">You don't have permission to access this page.</p>
      <button
        onClick={() => window.history.back()}
        className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
      >
        Go Back
      </button>
    </div>
  </div>
);

function PannelRoutes() {
  const permissions = getElevateUser()?.roleData?.permission;
  console.log("permissions", permissions);

  return (
    <Routes>
      {/* Dashboard route - accessible to all */}

      <Route
        path="/"
        element={
          <ProtectedRoute module="dashboard" action="read" >
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route path="/survey" element={<Survey />} />
      <Route path="/survey/add" element={<AddSurvey />} />
      <Route path="/survey/add/:id" element={<AddSurvey />} />
      <Route path="/ngb" element={<NoGstBills />} />
      <Route path="/expense/add" element={<AddExpense />} />
      <Route path="/expense" element={<Expense />} />
      <Route path="/expense/:id" element={<AddExpense />} />
      <Route path="/closing-days" element={<ClosingDays />} />

      {/* Kiosk Management Routes */}
      <Route path="/kiosk-management" element={<KioskManagement />} />
      <Route path="/kiosk-management/home-screen" element={<HomeScreenManagement />} />
      <Route path="/kiosk-management/dashboard/:id" element={<KioskDashboard />} />
      <Route path="/kiosk-management/dashboard/:id/banners" element={<BannerManagement />} />
      <Route path="/kiosk-management/dashboard/:id/ads" element={<AdManagement />} />
      <Route path="/kiosk-management/dashboard/:id/quicksale" element={<KiosQuicksale />} />

      <Route path='/homeservices' element={<HomeServices />} />
      <Route path='addAtHomeParent' element={<AddAtHomeParent />} />
      <Route path='atHomeParent/edit/:id' element={<AddAtHomeParent />} />
      <Route path='addAtHomeChild/:id' element={<AddAtHomeChild />} />
      <Route path='editAtHomeChild/:id' element={<EditAtHomeChild />} />




      <Route path='service-color' element={<HairColorServices />} />
      <Route path='service-color/add' element={<HairColorManagement />} />
      <Route path='service-color/edit/:id' element={<HairColorManagement />} />








      {/* Cash Management Routes */}
      <Route
        path="/payment-reports"
        element={
          <ProtectedRoute module="paymentReports" action="read">
            <div className="p-6 bg-white rounded-lg shadow">
              <h1 className="text-2xl font-bold text-gray-900 mb-4">Payment Reports</h1>
              <p className="text-gray-600">Payment reports functionality coming soon...</p>
            </div>
          </ProtectedRoute>
        }
      />

      <Route
        path="/cash-register"
        element={
          <ProtectedRoute module="cashRegister" action="read">
            <div className="p-6 bg-white rounded-lg shadow">
              <h1 className="text-2xl font-bold text-gray-900 mb-4">Cash Register</h1>
              <p className="text-gray-600">Cash register functionality coming soon...</p>
            </div>
          </ProtectedRoute>
        }
      />


      <Route path="/reports/attendance" element={<AttendanceReport />} />
      <Route path="/reports/bills" element={<BillReportMaster />} />


      <Route path="/home-services" element={<HomeServicesMaster />} />
      <Route path="/app-control" element={<AppControl />} />
      <Route path="/app-control/category" element={<CategoryMaster />} />
      <Route path="/app-control/category/add" element={<AddCategory />} />
      <Route path="/app-control/category/edit/:id" element={<AddCategory />} />
      <Route path="/app-control/service-group" element={<ServiceGroupConfig />} />
      <Route path="/app-control/notifications" element={<NotificationMaster />} />
      <Route path="/app-control/notifications/send" element={<SendNotification />} />
      <Route path="/app-control/maintenance" element={<MaintenanceModeMaster />} />
      <Route path="/app-control/maintenance/add" element={<AddMaintenanceMode />} />
      <Route path="/app-control/maintenance/edit/:id" element={<AddMaintenanceMode />} />
      <Route path="/app-control/live-users" element={<LiveUsers />} />
      <Route path="/app-control/versions" element={<VersionMaster />} />
      <Route path="/app-control/versions/add" element={<AddVersion />} />
      <Route path="/app-control/versions/edit/:id" element={<AddVersion />} />
      <Route path="/app-control/ota" element={<ClientOtaUpdates />} />
      <Route path="/partner-app-control" element={<PartnerAppControl />} />
      <Route path="/partner-app-control/analytics" element={<PartnerAnalytics />} />
      <Route path="/partner-app-control/map" element={<PartnerMap />} />
      <Route path="/partner-app-control/ota" element={<OtaUpdates />} />
      {/* <Route path="/appconfig" element={<AppConfiguration />} /> */}

      {/* App Configuration - Project Config Routes */}

      {/* Unauthorized route */}
      <Route path="/unauthorized" element={<Unauthorized />} />

      {/* Floor route - accessible to all for now */}
      <Route path="/floor" element={<FloorMaster />} />

      {/* Services Routes */}
      <Route
        path="addParent"
        element={
          <ProtectedRoute module="services" action="write" >
            <AddParent />
          </ProtectedRoute>
        }
      />
      <Route
        path="parentservice/editparentservice/:id"
        element={
          <ProtectedRoute module="services" action="write" >
            <AddParent />
          </ProtectedRoute>
        }
      />
      <Route
        path="addChild/:id"
        element={
          <ProtectedRoute module="services" action="write" >
            <AddChild />
          </ProtectedRoute>
        }
      />
      <Route
        path="editChild/:id"
        element={
          <ProtectedRoute module="services" action="write" >
            <EditChildService />
          </ProtectedRoute>
        }
      />
      <Route
        path="services"
        element={
          <ProtectedRoute module="services" action="read">
            <Services />
          </ProtectedRoute>
        }
      />



      <Route
        path="bestservices"
        element={
          <BestServices />
        }
      />
      <Route
        path="bestservices/add"
        element={
          <AddBestService />
        }
      />
      <Route
        path="bestservices/edit/:id"
        element={
          <AddBestService />
        }
      />



      {/* master services */}
      <Route
        path="master-services"
        element={
          <ProtectedRoute module="services" action="read">
            <MasterService />
          </ProtectedRoute>
        }
      />

      {/* service dashboard */}
      <Route
        path="service-dashboard"
        element={
          <ProtectedRoute module="services" action="read">
            <ServiceDashboard />
          </ProtectedRoute>
        }
      />

      {/* master products */}
      <Route
        path="master-products"
        element={
          <ProtectedRoute module="product" action="read">
            <ProductMaster />
          </ProtectedRoute>
        }
      />

      {/* Inventory Management */}
      <Route
        path="inventory-management"
        element={
          <ProtectedRoute module="inventory" action="read">
            <InventoryManagement />
          </ProtectedRoute>
        }
      />

      <Route
        path="salonServices"
        element={
          // <ProtectedRoute module="masterServices" action="read">
          <SalonService />
          // </ProtectedRoute>
        }
      />
      <Route
        path="addSalonParent"
        element={
          <AddSalonParent />
        }
      />
      <Route
        path="salonParent/edit/:id"
        element={
          <AddSalonParent />
        }
      />
      <Route
        path="addSalonChild/:id"
        element={
          <AddSalonChild />
        }
      />
      <Route
        path="editSalonChild/:id"
        element={
          <EditSalonChild />
        }
      />

      {/* User Management Routes */}
      <Route
        path="users"
        element={
          <ProtectedRoute module="user" action="read">
            <UserMaster />
          </ProtectedRoute>
        }
      />
      <Route
        path="users/add"
        element={
          <ProtectedRoute module="user" action="write">
            <AddUser />
          </ProtectedRoute>
        }
      />
      <Route
        path="users/edit/:id"
        element={
          <ProtectedRoute module="user" action="write">
            <AddUser />
          </ProtectedRoute>
        }
      />

      {/* Attendance Management Routes */}
      <Route
        path="attendance"
        element={
          <ProtectedRoute module="attendance" action="read">
            <AttendanceMaster />
          </ProtectedRoute>
        }
      />

      {/* Client Management Routes */}
      <Route
        path="client/add"
        element={
          <ProtectedRoute module="client" action="write">
            <AddClient />
          </ProtectedRoute>
        }
      />
      <Route
        path="client/edit/:id"
        element={
          <ProtectedRoute module="client" action="write">
            <AddClient />
          </ProtectedRoute>
        }
      />
      <Route
        path="client"
        element={
          <ProtectedRoute module="client" action="read">
            <ClientMaster />
          </ProtectedRoute>
        }
      />

      {/* Unit Management Routes */}
      <Route
        path="unit"
        element={
          <ProtectedRoute module="unit" action="read">
            <UnitMaster />
          </ProtectedRoute>
        }
      />
      <Route
        path="unit/add"
        element={
          <ProtectedRoute module="unit" action="write">
            <AddUnit />
          </ProtectedRoute>
        }
      />
      <Route
        path="unit/edit/:id"
        element={
          <ProtectedRoute module="unit" action="write">
            <AddUnit />
          </ProtectedRoute>
        }
      />

      {/* Vendor Management Routes */}
      <Route
        path="vendormanagement"
        element={
          <ProtectedRoute module="vendor" action="read">
            <VendorManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="vendormanagement/add"
        element={
          <ProtectedRoute module="vendor" action="write">
            <AddVendor />
          </ProtectedRoute>
        }
      />
      <Route
        path="vendormanagement/edit/:id"
        element={
          <ProtectedRoute module="vendor" action="write">
            <AddVendor />
          </ProtectedRoute>
        }
      />

      {/* Seat Management Routes */}
      <Route
        path="seat"
        element={
          <ProtectedRoute module="seat" action="read">
            <SeatMaster />
          </ProtectedRoute>
        }
      />
      <Route
        path="seat/add"
        element={
          <ProtectedRoute module="seat" action="write">
            <AddSeat />
          </ProtectedRoute>
        }
      />
      <Route
        path="seat/edit/:id"
        element={
          <ProtectedRoute module="seat" action="write">
            <AddSeat />
          </ProtectedRoute>
        }
      />

      {/* Stock Management Routes */}


      {/* Staff Management Routes */}
      <Route
        path="staffdashboard/attendance"
        element={
          <ProtectedRoute module="staff" action="read">
            <StaffAttendance />
          </ProtectedRoute>
        }
      />
      <Route
        path="staffdashboard"
        element={
          <ProtectedRoute module="staff" action="read">
            <StaffDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="addStaff"
        element={
          <ProtectedRoute module="staff" action="write">
            <AddStaff />
          </ProtectedRoute>
        }
      />
      <Route
        path="staff"
        element={
          <ProtectedRoute module="staff" action="read">
            <Staff />
          </ProtectedRoute>
        }
      />
      <Route
        path="staff/editStaff/:id"
        element={
          <ProtectedRoute module="staff" action="write">
            <AddStaff />
          </ProtectedRoute>
        }
      />


      {/* Product Management Routes */}
      <Route
        path="products"
        element={
          <ProtectedRoute module="product" action="read">
            <Products />
          </ProtectedRoute>
        }
      />
      <Route
        path="addProduct"
        element={
          <ProtectedRoute module="product" action="write">
            <AddProducts />
          </ProtectedRoute>
        }
      />
      <Route
        path="products/editProduct/:id"
        element={
          <ProtectedRoute module="product" action="write">
            <AddProducts />
          </ProtectedRoute>
        }
      />

      {/* General Master Routes */}
      <Route
        path="generalmaster"
        element={
          <ProtectedRoute module="generalMaster" action="read">
            <GeneralMaster />
          </ProtectedRoute>
        }
      />
      <Route
        path="generalmaster/add"
        element={
          <ProtectedRoute module="generalMaster" action="write">
            <AddGeneralMaster />
          </ProtectedRoute>
        }
      />
      <Route
        path="generalmaster/edit/:id"
        element={
          <ProtectedRoute module="generalMaster" action="write">
            <AddGeneralMaster />
          </ProtectedRoute>
        }
      />

      {/* File Management Routes */}
      <Route
        path="upload"
        element={
          <ProtectedRoute module="fileManagement" action="write">
            <FileUpload />
          </ProtectedRoute>
        }
      />
      <Route
        path="ratecard"
        element={
          // <ProtectedRoute module="file management" action="write">
          <RateCard />
          // </ProtectedRoute>
        }
      />



      <Route path="quicksale" element={<QuickSaleMaster />} />
      <Route path="quicksale/add" element={<BillingSearch />} />
      <Route path="quicksale/add/:id" element={<Billing />} />

      {/* Staff Billing Routes */}


      {/* AppoinmentMaster */}
      <Route
        path="appoinments"
        element={
          // <ProtectedRoute module="appoinmentMaster" action="read">
          <AppoinmentMaster />
          // </ProtectedRoute>
        }
      />

      <Route
        path="appoinments/add"
        element={
          // <ProtectedRoute module="appoinmentMaster" action="read">
          <AppointmentManagementMaster />
          // </ProtectedRoute>
        }
      />

      <Route
        path="appoinments/edit/:id"
        element={
          // <ProtectedRoute module="appoinmentMaster" action="write">
          <AppointmentManagementMaster />
          // </ProtectedRoute>
        }
      />


      {/* AppoinmentMaster */}


      <Route
        path="staffBilling"
        element={
          <ProtectedRoute module="staffBilling" action="read">
            <StaffBillManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="staffBilling/add"
        element={
          <ProtectedRoute module="staffBilling" action="write">
            <AutoBillingPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="staffBilling/edit/:id"
        element={
          <ProtectedRoute module="staffBilling" action="write">
            <EditStafffBill />
          </ProtectedRoute>
        }
      />


      {/* Auto Billing Routes */}
      <Route path="autoBilling" element={<AutoBillingMaster />} />
      <Route path="autoBilling/edit/:id" element={<EditQuickSale />} />


      {/* Client Followup */}
      <Route path="clientFollowup" element={<ClientFollowup />} />
      <Route path="clientFollowup/add" element={<AddClientFollowup />} />
      <Route path="clientFollowup/edit/:id" element={<AddClientFollowup />} />


      {/* Client Feedback */}
      <Route path="client-feedback" element={<ClientFeedback />} />

      {/* Client Analytics */}
      <Route path="clientAnalytics" element={<ClientAnalytics />} />
      <Route path="businessForecasting" element={<BusinessForecasting />} />

      <Route
        path="roles-and-permission"
        element={
          <ProtectedRoute module="rolesAndPermissions" action="read">
            <RoleMaster />
          </ProtectedRoute>
        }
      />
      <Route
        path="roles-and-permission/add"
        element={
          <ProtectedRoute module="rolesAndPermissions" action="write">
            <AddRole />
          </ProtectedRoute>
        }
      />
      <Route
        path="roles-and-permission/edit/:id"
        element={
          <ProtectedRoute module="rolesAndPermissions" action="write">
            <EditRole />
          </ProtectedRoute>
        }
      />
      <Route
        path="advertisement"
        element={
          <ProtectedRoute module="advertisement" action="read">
            <Advertiesment />
          </ProtectedRoute>
        }
      />
      <Route
        path="billboard"
        element={
          <ProtectedRoute module="advertisement" action="read">
            <BillBoardAds />
          </ProtectedRoute>
        }
      />
      <Route
        path="addbillboard"
        element={
          <ProtectedRoute module="advertisement" action="write">
            <AddBillBoard />
          </ProtectedRoute>
        }
      />
      <Route
        path="addadvertisement"
        element={
          <ProtectedRoute module="advertisement" action="write">
            <AddAdvertiesment />
          </ProtectedRoute>
        }
      />
      <Route
        path="advertiesment/editadvertiesment/:id"
        element={
          <ProtectedRoute module="advertisement" action="write">
            <AddAdvertiesment />
          </ProtectedRoute>
        }
      />
      <Route
        path="billboard/editbillboard/:id"
        element={
          <ProtectedRoute module="advertisement" action="write">
            <AddBillBoard />
          </ProtectedRoute>
        }
      />


      <Route
        path="registerdevice/add"
        element={
          <RegisterDevice />
        }
      />
      <Route
        path="registerdevice"
        element={
          <DeviceMaster />
        }
      />
      <Route
        path="registerdevice/edit/:id"
        element={
          <RegisterDevice />
        }
      />
      <Route
        path="registerdevice/ads/:id"
        element={
          <DeviceAds />
        }
      />

      {/* Membership */}

      <Route
        path="membership"
        element={
          <ProtectedRoute module="membership" action="read">
            <Membership />
          </ProtectedRoute>
        }
      />
      <Route
        path="membership/add"
        element={
          <ProtectedRoute module="membership" action="write">
            <AddMembship />
          </ProtectedRoute>
        }
      />
      <Route
        path="membership/edit/:id"
        element={
          <ProtectedRoute module="membership" action="write">
            <AddMembship />
          </ProtectedRoute>
        }
      />

      {/* wallet */}

      <Route
        path="coupon"
        element={
          // <ProtectedRoute module="coupon" action="read">
          <CouponMaster />
          // </ProtectedRoute>
        }
      />
      <Route
        path="coupon/add"
        element={
          // <ProtectedRoute module="membership" action="write">
          <AddCoupon />
          // </ProtectedRoute>
        }
      />
      <Route
        path="coupon/edit/:id"
        element={
          // <ProtectedRoute module="membership" action="write">
          <AddCoupon />
          // </ProtectedRoute>
        }
      />
      {/* coupon */}

      <Route
        path="account"
        element={
          // <ProtectedRoute module="coupon" action="read">
          <AccountMaster />
          // </ProtectedRoute>
        }
      />
      <Route
        path="account/add"
        element={
          // <ProtectedRoute module="membership" action="write">
          <AddAccount />
          // </ProtectedRoute>
        }
      />
      <Route
        path="account/edit/:id"
        element={
          // <ProtectedRoute module="membership" action="write">
          <AddAccount />
          // </ProtectedRoute>
        }
      />




      {/* accounts */}



      {/* stock */}

      <Route
        path="incentive"
        element={
          // <ProtectedRoute module="coupon" action="read">
          <IncentiveMaster />
          // </ProtectedRoute>
        }
      />
      <Route
        path="incentive/add"
        element={
          // <ProtectedRoute module="membership" action="write">
          <AddIncentive />
          // </ProtectedRoute>
        }
      />
      <Route
        path="incentive/edit/:id"
        element={
          // <ProtectedRoute module="membership" action="write">
          <AddIncentive />
          // </ProtectedRoute>
        }
      />

      {/* incentives */}



      <Route
        path="wallet"
        element={
          // <ProtectedRoute module="wallet" action="read">
          <WalletManagement />
          // </ProtectedRoute>
        }
      />

      {/* packages */}
      <Route
        path="packages"
        element={
          <ProtectedRoute module="packages" action="read">
            <Packages />
          </ProtectedRoute>
        }
      />
      <Route
        path="packages/add"
        element={
          <ProtectedRoute module="packages" action="write">
            <AddPackage />
          </ProtectedRoute>
        }
      />
      <Route
        path="packages/edit/:id"
        element={
          <ProtectedRoute module="packages" action="write">
            <AddPackage />
          </ProtectedRoute>
        }
      />



      {/* whatsaap */}
      <Route
        path="whatsapp"
        element={
          // <ProtectedRoute module="packages" action="write">
          <WhatsappMaster />
          // </ProtectedRoute>
        }
      />



      {/* bills master */}

      <Route
        path="bills"
        element={
          <BillMaster />
        }
      />

      {/* payments */}
      <Route
        path="payments"
        element={
          <PaymentMaster />
        }
      />

      {/* app bookings */}
      <Route
        path="app-bookings"
        element={
          <AppBookingMaster />
        }
      />

      <Route
        path="at-home-bills"
        element={
          <AtHomeBillMaster />
        }
      />

      <Route
        path="askai/"
        element={

          <Askai />

        }
      />


      <Route path="/stock/warehouse" element={<Warehouse />} />
      <Route path="/warehouse/add" element={<AddWarehouse />} />
      <Route path="/warehouse/transfer" element={<TransferStock />} />
      <Route path="/stock/professionals" element={<Professionals />} />
      <Route path="/stock/retails" element={<Retails />} />
      <Route path="/stock/dashboard" element={<StockDashboard />} />
      <Route path="/stock/buy" element={<BuyStockMaster />} />
      <Route path="/stock/orders" element={<Orders />} />
      <Route path="/reports/staff" element={<StaffReportMaster />} />
      <Route path="/reports/payment-distribution" element={<PaymentDistributionReport />} />



      <Route
        path="kioskservices"
        element={
          <KioskServices />
        }
      />

      <Route
        path="app-configuration/projects"
        element={
          <ClientWebApp />
        }
      />
      <Route
        path="app-configuration/payment-method"
        element={
          <PaymentMethod />
        }
      />
      {/* Keep old route for backward compatibility */}
      <Route
        path="app-configraution"
        element={
          <ClientWebApp />
        }
      />

      <Route
        path="website-configuration"
        element={
          <WebsiteConfiguration />
        }
      />


      {/* Kios Parent Routes */}
      <Route
        path="addKiosParent"
        element={
          <AddKiosParent />
        }
      />
      <Route
        path="kiosParent/edit/:id"
        element={
          <AddKiosParent />
        }
      />

      {/* Kios Child Routes */}
      <Route
        path="addKiosChild/:id"
        element={
          <AddKiosChild />
        }
      />
      <Route
        path="editKiosChild/:id"
        element={
          <EditKiosChild />
        }
      />
















      <Route path="test" element={<Test />} />
      <Route path="/taskmanagement" element={<TaskMaster />} />
      <Route path="/taskmanagement/add" element={<AddTask />} />
      <Route path="/taskmanagement/edit/:id" element={<EditTask />} />
      <Route path="/taskmanagement/task" element={<MyTask />} />











    </Routes>
  );
}

export default PannelRoutes;